import { render, staticRenderFns } from "./customMenuDropdown.vue?vue&type=template&id=279dd1b2&scoped=true&"
import script from "./customMenuDropdown.vue?vue&type=script&lang=js&"
export * from "./customMenuDropdown.vue?vue&type=script&lang=js&"
import style0 from "./customMenuDropdown.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./customMenuDropdown.vue?vue&type=style&index=1&id=279dd1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279dd1b2",
  null
  
)

export default component.exports